import { useEffect } from 'react';
export function useIndicationError(error, existingError) {
  useEffect(() => {
    const combinedError = error || existingError;

    if (combinedError?.message === "Minor patient enrollment without required LAP fields" || combinedError?.message === "Cannot submit enrollment request, indication is missing." || combinedError?.message === "DOB must be in YYYY-MM-DD format" || combinedError?.message === "Invalid date of birth" || combinedError?.message === "DOB cannot be in the future" || combinedError?.message === "You must be at least 18 years old") {
      localStorage.setItem('Error', combinedError.message);
    } else {
      localStorage.removeItem('Error');
    }
  }, [error, existingError]);
}
